import { c as _c } from "react/compiler-runtime";
import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { URLS } from '@/constants/api';
import { apiSelfCareFetcher } from '../fetcher';
import { FetchArgs, SearchParams } from '@/utils/fetcher';
import { Partners } from '@/types/partners';
export type PartnersQueryOptions = FetchArgs & {
  initialData?: Partners;
};
export function usePartnersQuery(t0) {
  const $ = _c(13);
  let fetchArgs;
  let initialData;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      initialData,
      ...fetchArgs
    } = t0);
    t2 = useInfiniteQuery;
    t1 = QUERY_KEYS.partners(fetchArgs.searchParams);
    $[0] = t0;
    $[1] = fetchArgs;
    $[2] = initialData;
    $[3] = t1;
    $[4] = t2;
  } else {
    fetchArgs = $[1];
    initialData = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] !== fetchArgs) {
    t3 = async t4 => {
      const {
        pageParam
      } = t4;
      return fetchPartners({
        ...fetchArgs.searchParams,
        ...(pageParam || {})
      });
    };
    $[5] = fetchArgs;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== initialData) {
    t4 = initialData ? {
      pages: [initialData],
      pageParams: [undefined]
    } as InfiniteData<Partners, unknown> : undefined;
    $[7] = initialData;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t3,
      getNextPageParam: _temp,
      initialPageParam: undefined,
      initialData: t4
    };
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t2(t5);
}
function _temp(lastPage) {
  if (!lastPage) {
    return;
  }
  const after = new URLSearchParams(new URL(`${process.env.NEXT_PUBLIC_API_URL}${lastPage?.pagingInfo.nextPage}`).searchParams).get("after");
  return after ? {
    after
  } : undefined;
}
export async function fetchPartners(searchParams: SearchParams): Promise<Partners | undefined> {
  const res = await apiSelfCareFetcher<Promise<Partners>>(URLS.partners, {
    searchParams
  });
  return res.json;
}